// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as TableView from "../../resources/tables/TableView.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as CatalogProduct from "./CatalogProduct.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function keyExtractor(row) {
  return row.id + "-status";
}

let Row = {
  keyExtractor: keyExtractor
};

let columns = [
  {
    key: "shopname",
    name: I18n.t("Shop/Warehouse"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 150
      }
    },
    render: param => JsxRuntime.jsx(TextStyle.make, {
      children: param.data.shopName
    })
  },
  {
    key: "status",
    name: I18n.t("Status"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 110
      },
      width: {
        NAME: "fr",
        VAL: 0
      }
    },
    render: param => {
      let status = param.data.status;
      if (status !== undefined) {
        return JsxRuntime.jsx(CatalogProduct.Status.Badge.make, {
          value: status
        });
      } else {
        return null;
      }
    }
  }
];

function CatalogProductStatusTableCard(props) {
  let rows = props.shopsProduct.map(product => ({
    id: product.id,
    shopName: product.shopName,
    status: product.status
  }));
  return JsxRuntime.jsx(Card.make, {
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(TableView.make, {
        data: {
          TAG: "Done",
          _0: {
            TAG: "Ok",
            _0: rows
          }
        },
        columns: columns,
        keyExtractor: keyExtractor,
        hideCard: true
      }),
      spaceTop: "small"
    }),
    title: I18n.t("Statuses"),
    variation: "table"
  });
}

let make = React.memo(CatalogProductStatusTableCard);

let Config;

export {
  Config,
  Row,
  columns,
  make,
}
/* columns Not a pure module */
